import VerifyEmail from './VerifyEmailContainer';

export default VerifyEmail;